<!-- <div class="container">
    <h1 class="text-center"> Log File Convert in CSV</h1>
    <form [formGroup]="logForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label>Log Date:</label>
        <div class="input-group">
            <input type="text"
            id="LogDate"
            placeholder="Log Date"
            [(ngModel)]="f.LogDate"
            class="form-control"
            [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'DD-MM-YYYY' }"
            bsDatepicker>
        </div>
      </div>

      <button type="submit" class="btn btn-login primary form-control">Search</button>

    </form>
  </div> -->

<div class="col-md-12 main-heading">

  <div class="d-flex">
    <a routerLink="/index">
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">Transaction Log File</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <!-- <form [formGroup]="logForm" (ngSubmit)="onSubmit()"> -->
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section width-lg-metro" style="width: 75%;">
        <div class="heading-m" style="height: 1px;">
        </div>
        <div class="list-sidebar">
          <table style="width: 100%;">
            <tbody>
              <tr>
                <td>
                  <style>
                    .formFilter tbody tr td {
                      padding-left: 10px;
                    }
                  </style>
                  <table class="formFilter">
                    <tbody>
                      <tr>


                        <td>
                          Log Date
                        </td>
                        <td>
                          <input type="text" placeholder="Log Date" [(ngModel)]="LogDate" class="form-control"
                            [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'DD-MM-YYYY' }"
                            bsDatepicker>
                        </td>
                        <td>
                          <!-- <button class="btn btn-primary" (click)="SearchData()">Search</button> -->
                          <button type="submit" (click)="SearchData()"
                            class="btn btn-login primary form-control">Download</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <style>
                    .formData {
                      margin: 20px;
                      border: solid 1px darkgray;
                      width: calc(100% - 20px);
                    }

                    .formData thead tr th {
                      padding: 10px;
                    }

                    .formData tbody tr td {
                      padding: 10px;
                    }

                    .formData tbody tr td {
                      font-weight: normal;
                    }
                  </style>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- </form> -->
</div>